import { styled } from "@mui/material/styles";
import { COLORS } from "../../constants/colors";

export const PageContentInner = styled("div")`
  padding: 1em;
  background: ${COLORS.SURFACE_PAGE};
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  min-height: 100%;
  position: relative;
  z-index: 1;
  overflow-x: hidden;
  margin-left: 256px;

  & > * {
    width: 100%;
  }
`;
